const PLATFORM_POTENTIAL_FEE = "platform_potential_fee";
const PAGE_VIEWS = "page_views";
const CHECKOUT_STARTED_SUBTOTAL = "checkout_started_subtotal";
const CHECKOUT_COMPLETED_SUBTOTAL = "checkout_completed_subtotal";
const CHECKOUT_VALUE_CAPTURED = "checkout_value_captured";
const CHECKOUT_COMPLETED_PRODUCTS_SUBTOTAL =
  "checkout_completed_products_subtotal";
const CHECKOUT_COMPLETED_PRODUCTS_COUNT = "checkout_completed_products_count";
const PAGE_CHECKOUT_FUNNEL = "page_checkout_funnel";
const LINK_CHECKOUT_FUNNEL = "link_checkout_funnel";

export const EVENT_UID = {
  PLATFORM_POTENTIAL_FEE,
  PAGE_VIEWS,
  CHECKOUT_STARTED_SUBTOTAL,
  CHECKOUT_COMPLETED_SUBTOTAL,
  CHECKOUT_VALUE_CAPTURED,
  PAGE_CHECKOUT_FUNNEL,
  LINK_CHECKOUT_FUNNEL,
  CHECKOUT_COMPLETED_PRODUCTS_SUBTOTAL,
  CHECKOUT_COMPLETED_PRODUCTS_COUNT
};

export const UID_LAYOUT = {
  [PAGE_CHECKOUT_FUNNEL]: {
    width: 4
  },
  [LINK_CHECKOUT_FUNNEL]: {
    width: 4
  },
  [PAGE_VIEWS]: {
    width: 1
  },
  [CHECKOUT_STARTED_SUBTOTAL]: {
    width: 1
  },
  [CHECKOUT_COMPLETED_SUBTOTAL]: {
    width: 1
  },
  [CHECKOUT_VALUE_CAPTURED]: {
    width: 1
  },
  [PLATFORM_POTENTIAL_FEE]: {
    width: 1
  },
  [CHECKOUT_COMPLETED_PRODUCTS_SUBTOTAL]: {
    width: 2
  },
  [CHECKOUT_COMPLETED_PRODUCTS_COUNT]: {
    width: 2
  }
};

export const TOP_VIEWS_ORDER = [
  PAGE_CHECKOUT_FUNNEL,
  PAGE_VIEWS,
  CHECKOUT_STARTED_SUBTOTAL,
  CHECKOUT_COMPLETED_SUBTOTAL,
  CHECKOUT_VALUE_CAPTURED
];

export const ALL_VIEWS_ORDER = [
  PAGE_CHECKOUT_FUNNEL,
  PAGE_VIEWS,
  CHECKOUT_STARTED_SUBTOTAL,
  CHECKOUT_COMPLETED_SUBTOTAL,
  CHECKOUT_VALUE_CAPTURED,
  CHECKOUT_COMPLETED_PRODUCTS_SUBTOTAL,
  CHECKOUT_COMPLETED_PRODUCTS_COUNT,
  PLATFORM_POTENTIAL_FEE
];

export const PAGE_VIEWS_ORDER = [
  PAGE_CHECKOUT_FUNNEL,
  PAGE_VIEWS,
  CHECKOUT_STARTED_SUBTOTAL,
  CHECKOUT_COMPLETED_SUBTOTAL,
  CHECKOUT_VALUE_CAPTURED,
  CHECKOUT_COMPLETED_PRODUCTS_SUBTOTAL,
  CHECKOUT_COMPLETED_PRODUCTS_COUNT
];

export const LINK_VIEWS_ORDER = [
  LINK_CHECKOUT_FUNNEL,
  CHECKOUT_STARTED_SUBTOTAL,
  CHECKOUT_COMPLETED_SUBTOTAL,
  CHECKOUT_VALUE_CAPTURED
];

/**
 * Setup links dont have any subtotal computations so we just measure funnel
 */
export const SETUP_LINK_VIEWS_ORDER = [LINK_CHECKOUT_FUNNEL];
